import React, { useState, useEffect } from "react";
import "../../components/PetMicrochipQuantity/PetMicrochipQuantity.css";

const PetMicrochipQuantity = () => {
  return (
    <div className="container-fluid">
      <br />

      <div className="petMicrochipQuantityDetail">
        <form className="petMicrochipQuantity-form">
        <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Product Name</td>
              <td>Country</td>
              <td>State</td>
            </tr>

            <tr>
              <td>
              <select className="dropdown-country">
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  <option value="1">Crate 48 inch</option>
                </select>
              </td>
              <td>
                <select className="dropdown-country">
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  <option value="1">India</option>
                </select>
              </td>
              <td>
              <select className="dropdown-country">
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  <option value="1">Haryana</option>
                </select>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>City</td>
              <td>Quatity</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
              <select className="dropdown-country">
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  <option value="1">Gurgaon</option>
                </select>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addPetMicrochipQuantity-button">
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default PetMicrochipQuantity;
